/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

var InvestmentsListing = {};

( function( $ ) {

	InvestmentsListing.load = function( selectedMenu ) {
		$( '.section-logos .items .item' ).each( function() {
			var categories = $( this ).data( 'category' );
			
			if( $.inArray( parseInt( selectedMenu.data( 'value' ) ), categories ) > -1 ) {
				$( this ).show();
			} else {
				$( this ).hide();
			}
		} );
	};

	$( document ).ready( function() {
		if( $('.section-logos').hasClass( 'all-logos' ) ) {
			return;
		}
		
		var submenus = $( '.investments-listing .header-buttons' );
		
		submenus.find( 'a' ).on( 'click keydown', function( e ) {
			var etype = e.type;
			
			if( etype === 'keydown' && ( e.keyCode !== 13 && e.keyCode !== 32 ) ) {
				return true;
			}

			e.preventDefault();

			submenus.find( 'a' ).removeClass( 'active' );

			$( this ).addClass( 'active' );

			InvestmentsListing.load( $( this ) );
		} );
    } );

} )( jQuery );
